import type { Meta, StoryObj } from "@storybook/react";

import { fakeGroupClassSeries } from "@/__mocks__/groupClassSeries";
import type { GroupClassSeriesListProps } from "@/ui/components/groupClasses/series/GroupClassSeriesList";
import GroupClassSeriesList from "@/ui/components/groupClasses/series/GroupClassSeriesList";

const StoryMeta: Meta<GroupClassSeriesListProps> = {
  title: "Components/Group Classes/Series List",
  component: GroupClassSeriesList,
  argTypes: {
    forWhom: { control: "text" },
    groupClasses: { control: "object" },
    isAppUserSupport: { control: "boolean" },
    isListLoading: { control: "boolean" },
  },
  args: {
    forWhom: "Olivia",
    groupClasses: [
      fakeGroupClassSeries(),
      fakeGroupClassSeries(),
      fakeGroupClassSeries(),
    ],
    isAppUserSupport: false,
    isListLoading: false,
  },
};

type Story = StoryObj<GroupClassSeriesListProps>;

const Primary: Story = {};

const UserProxy: Story = {
  args: {
    isAppUserSupport: true,
  },
};

export { Primary, UserProxy };
export default StoryMeta;
